import { createI18n } from 'vue-i18n'
import { SupportedLocales, DefaultLocale, type SupportedLocale } from '@gencay-akademi/shared-types'
import tr from './locales/tr.json'
import en from './locales/en.json'

export type MessageSchema = typeof tr

const messages = {
  tr,
  en,
}

/**
 * Get initial locale from localStorage or browser preference
 */
function getInitialLocale(): SupportedLocale {
  // Resolve identically to the locale store (localStorage → DefaultLocale).
  // We deliberately do NOT fall back to navigator.language: the app is
  // TR-first and the language switcher ignores browser preference, so guessing
  // from the browser here made i18n start in EN while the switcher showed TR —
  // the two only re-synced after a manual locale change.
  const stored = localStorage.getItem('locale')
  if (stored && SupportedLocales.includes(stored as SupportedLocale)) {
    return stored as SupportedLocale
  }

  return DefaultLocale
}

/**
 * Create and configure vue-i18n instance
 */
export const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
})

export { SupportedLocales, DefaultLocale, type SupportedLocale }
